import React from "react";
import ReactApexChart from "react-apexcharts";

const YearAreaChart = ({ pnlGraphData, graphPnl }) => {
  const dates = pnlGraphData?.map((item) => item.label) || [];
  const pnlValues = pnlGraphData?.map((item) => item.pnl) || [];

  const lineColor = graphPnl >= 0 ? "#00C853" : "#FF3D00";
  const gradientColor = graphPnl >= 0 ? "#66FF99" : "#FF8A80";

  const options = {
    chart: {
      type: "area",
      height: 300,
      toolbar: { show: false },
    },
    dataLabels: { enabled: false },
    stroke: {
      show: true,
      curve: "smooth",
      width: 2,
      colors: [lineColor],
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.6,
        opacityTo: 0,
      },
      colors: [gradientColor],
    },
    markers: { size: 0 },
    xaxis: {
      show: false,
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false },
      categories: dates,
    },
    yaxis: {
      show: false,
      min: Math.min(...pnlValues), // optional: to fix scale
      max: Math.max(...pnlValues), // optional: to fix scale
    },
    tooltip: { enabled: true },
    grid: { show: false },
  };

  const series = [
    {
      name: "PNL",
      data: pnlValues,
    },
  ];

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="area"
      height={160}
    />
  );
};

export default YearAreaChart;
